import "slick-carousel";

export default class Sliders {
  constructor(el) {
    this.el = el;
    this.cardsSlider = this.el.find(".js-cardsSlider");
    this.pgmCardsSlider = this.el.find(".pgm_cardsSlider");
    this.sectionSliderImageList = this.el.find(".js-sectionSliderImageList");
    this.sectionSliderContentList = this.el.find(
      ".js-sectionSliderContentList"
    );

    this.sectionSliderImageListOpencall = this.el.find(".open_call_home_image");
    this.sectionSliderContentListOpencall = this.el.find(
      ".open_call_home_block"
    );

    this.smallGallery = this.el.find(".js-small-gallery");
    this.largeGallery = this.el.find(".js-large-gallery");
    this.innerBannerGallery = this.el.find(".js-banner-images");
    this.homeBannerSlider = this.el.find(".js-mainBannerSlider");
    this.filmSlider = this.el.find(".film-slider");
    this.pgmTabSlider = this.el.find(".pgm_tab_slick");
    this.pgmTabItem = this.el.find(".pgm_tab_slick .tab_each");
    this.events();
  }

  events() {
    this.homeBannerSlider.slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      infinite: false,
      arrows: false,
      dots: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 8000,
      pauseOnHover: false,
      pauseOnFocus: false,
      pauseOnDotsHover: false,
      swipe: false,
    });

    this.innerBannerGallery.slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      autoplay: true,
      autoplaySpeed: 7000,
    });
    this.smallGallery.slick({
      arrows: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow:
        '<button class="slick-arrow slick-prev"><span class="icon-thick-arrow-left"></span></button>',
      nextArrow:
        '<button class="slick-arrow slick-next"><span class="icon-thick-arrow-right"></span></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 440,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    this.largeGallery.slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      prevArrow:
        '<button class="slick-arrow slick-prev"><span class="icon-slim-arrow-left"></span></button>',
      nextArrow:
        '<button class="slick-arrow slick-next"><span class="icon-slim-arrow-right"></span></button>',
    });

    this.cardsSlider.slick({
      infinite: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow:
        '<button class="slick-arrow slick-prev"><span class="icon-slim-arrow-left"></span></button>',
      nextArrow:
        '<button class="slick-arrow slick-next"><span class="icon-slim-arrow-right"></span></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    //this.handlePgmCardsSlider();

    this.filmSlider.slick({
      infinite: true,
      arrows: true,
      dots: true,
      cssEase: "cubic-bezier(.6,.04,.12,.96)",
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:
        '<button class="slick-arrow slick-prev"><span class="icon-slim-arrow-left"></span></button>',
      nextArrow:
        '<button class="slick-arrow slick-next"><span class="icon-slim-arrow-right"></span></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 640,
          settings: {
            dots: false,
            slidesToShow: 1,
          },
        },
      ],
    });

    this.pgmTabSlider.slick({
      infinite: false,
      arrows: false,
      dots: false,
      cssEase: "cubic-bezier(.6,.04,.12,.96)",
      slidesToShow: "auto",
      slidesToScroll: 1,
      rows: 0,
      prevArrow:
        '<button class="slick-arrow slick-prev"><span class="icon-slim-arrow-left"></span></button>',
      nextArrow:
        '<button class="slick-arrow slick-next"><span class="icon-slim-arrow-right"></span></button>',
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
            variableWidth: true,
          },
        },
      ],
    });
    //this.pgmTabItem.
    let $container = $("body");
    let $first_child = $(".pgm_tab_slick .tab_each:first-child").data("filter");
    //$(".pgm_cardsSlider." + $first_child).addClass("show");
    $(".pgm_cardsSlider").addClass("show");
    //this.handlePgmCardsSlider($first_child);
    this.handlePgmCardsSlider();
    $container.on("click", ".pgm_tab_slick .tab_each", (e) => {
      let filter = $(e.currentTarget).data("filter");
      $(".pgm_tab_slick .tab_each").removeClass("slick-current");
      $(e.currentTarget).addClass("slick-current");
      $(".pgm_cardsSlider").removeClass("show");
      $(".pgm_cardsSlider." + filter).addClass("show");
      this.handlePgmCardsSlider(filter);
    });

    this.sectionSliderImageList.not(".slick-initialized").slick({
      arrows: false,
      dots: true,
      adaptiveHeight: false,
      autoplay: false,
      // autoplay: 8000,
      infinite: true,
      variableWidth: false,
      slidesToShow: 1,
      draggable: false,
      focusOnSelect: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      asNavFor: ".js-sectionSliderContentList",
      cssEase: "cubic-bezier(.6,.04,.12,.96)",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: true,
            prevArrow:
              '<button class="slick-arrow slick-prev"><span class="icon-slim-arrow-left"></span></button>',
            nextArrow:
              '<button class="slick-arrow slick-next"><span class="icon-slim-arrow-right"></span></button>',
          },
        },
      ],
    });
    this.sectionSliderContentList.not(".slick-initialized").slick({
      arrows: true,
      nextArrow:
        '<button type="button" class="button button__line slick-arrow slick-next"><span class="button__line--line"></span>Next</button>',
      prevArrow: "",
      dots: false,
      adaptiveHeight: true,
      autoplay: true,
      autoplay: 8000,
      infinite: true,
      variableWidth: false,
      slidesToShow: 1,
      draggable: false,
      focusOnSelect: false,
      pauseOnFocus: false,
      pauseOnHover: true,
      pauseOnDotsHover: false,
      fade: true,
      asNavFor: ".js-sectionSliderImageList",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: false,
          },
        },
      ],
    });

    this.sectionSliderImageListOpencall.not(".slick-initialized").slick({
      arrows: false,
      dots: true,
      adaptiveHeight: false,
      autoplay: false,
      // autoplay: 8000,
      infinite: true,
      variableWidth: false,
      slidesToShow: 1,
      draggable: false,
      focusOnSelect: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      asNavFor: ".open_call_home_block",
      cssEase: "cubic-bezier(.6,.04,.12,.96)",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: true,
            prevArrow:
              '<button class="slick-arrow slick-prev"><span class="icon-slim-arrow-left"></span></button>',
            nextArrow:
              '<button class="slick-arrow slick-next"><span class="icon-slim-arrow-right"></span></button>',
          },
        },
      ],
    });
    this.sectionSliderContentListOpencall.not(".slick-initialized").slick({
      arrows: true,
      nextArrow:
        '<button type="button" class="button button__line slick-arrow slick-next"><span class="button__line--line"></span>Next</button>',
      prevArrow: "",
      dots: false,
      adaptiveHeight: true,
      autoplay: true,
      autoplay: 8000,
      infinite: true,
      variableWidth: false,
      slidesToShow: 1,
      draggable: false,
      focusOnSelect: false,
      pauseOnFocus: false,
      pauseOnHover: true,
      pauseOnDotsHover: false,
      fade: true,
      asNavFor: ".open_call_home_image",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  }

  //handlePgmCardsSlider(category) {
  handlePgmCardsSlider() {
    //let SliderClassName = ".pgm_cardsSlider." + category;
    let SliderClassName = ".pgm_cardsSlider";
    $(SliderClassName).slick({
      infinite: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      rows: 0,
      prevArrow:
        '<button class="slick-arrow slick-prev"><span class="icon-slim-arrow-left"></span></button>',
      nextArrow:
        '<button class="slick-arrow slick-next"><span class="icon-slim-arrow-right"></span></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
}
